
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import Link from 'next/link';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import widgetRoutes, { EOLA_ROUTES } from 'enums/routes';
import { Active_Schedulables } from 'shared/presenters/graphqlTypes';
import { OutletPresenter, SchedulablePresenter } from 'shared/presenters';
import { RecursivePartial, definedNotNull } from 'shared/presenters/presenter';
import translateChargeableTitle from 'helpers/translateChargeableTitle';
import { TopLevelCard } from 'helpers/determineTopLevelChargeableData';
import useStoreMarketplaceReferrals from 'state/useStoreMarketplaceReferrals';
import { arrayToString, stripHTMLTags, truncateString } from 'shared/helpers/stringUtilities';
import CoverImage from 'library/atoms/CoverImage';
import Divider from 'shared/library/atoms/Divider';
import GoogleStructuredDataBreadcrumb from 'library/molecules/GoogleStructuredData/GoogleStructuredDataBreadcrumbs';
import HeadContainer from 'library/atoms/HeadContainer';
import Header from 'library/molecules/Header';
import Icon from 'shared/library/atoms/Icon';
import Item, { ItemTextCta, ItemUl } from 'library/molecules/Item';
import Sidebar from 'library/pages/Home/Sidebar';
import { H5, Text } from 'library/atoms/Typography';
import { LayoutWithSidebar } from 'library/atoms/Layout';
import { ShowOnMarketplace } from 'shared/library/atoms/ConditionalMarketplace';
interface HomeCard extends Omit<TopLevelCard, 'schedulable'> {
    schedulable: SchedulablePresenter;
}
interface HomeProps {
    cards: HomeCard[];
    outlet: OutletPresenter;
}
const Home = ({ cards, outlet }: HomeProps) => {
    const { t } = useTranslation('common');
    const { query } = useRouter();
    const widgetSlug = query.widgetSlug as string;
    const metaDescription = outlet.description()
        ? truncateString(stripHTMLTags(outlet.description()), 200)
        : t(outlet?.address?.city
            ? 'meta-description-with-location'
            : 'meta-description-without-location', {
            outlet: outlet.name,
            location: outlet?.address?.city,
            activities: outlet.active_schedulables
                ? arrayToString(outlet?.active_schedulables.map((s: RecursivePartial<Active_Schedulables>) => definedNotNull(definedNotNull(s.activity_type).name)))
                : t('common:activities').toLowerCase()
        });
    // Store marketplace source for session if utm set
    useStoreMarketplaceReferrals();
    return (<>
      <StyledLayout head={<HeadContainer title={`${outlet.name} - ${t('book-now')}`} description={metaDescription}>
            {!outlet.feature_toggles?.marketplace_enabled ||
                (outlet.admin_forced_marketplace_disable && (<meta name="robots" content="noindex"/>))}
          </HeadContainer>} header={<Header />} sidebar={<Sidebar outlet={outlet}/>}>
        <>
          <CardContainer as="div">
            {cards?.map(card => {
            return (<Fragment key={card.title}>
                  <StyledLink href={card.href}>
                    <Item variant="slimCard" title={translateChargeableTitle(card.title, t)}>
                      <CoverImage src={card.cardImage} variant="thumb"/>
                      <ItemTextCta>
                        <H5>{translateChargeableTitle(card.title, t)}</H5>
                      </ItemTextCta>
                      <Icon name="card-arrow" size={24}/>
                    </Item>
                  </StyledLink>
                </Fragment>);
        })}
          </CardContainer>

          <ShowOnMarketplace>
            <Divider variant="solid"/>
            <AboutEolaContainer>
              <H5>{t('common:about-outlet', { name: 'eola' })}</H5>
              <Text fontStyle="p2" color="secondary">
                {t('common:about-eola-body')}
              </Text>
              <br />
              {outlet.address?.state && (<Text fontStyle="p2" color="secondary">
                  <Link href={EOLA_ROUTES.LOCATION.url({
                location: outlet.address?.state
            })}>
                    {t('common:explore-activities-in-state', {
                state: outlet.address?.state
            })}
                  </Link>
                </Text>)}
            </AboutEolaContainer>
          </ShowOnMarketplace>
          <GoogleStructuredDataBreadcrumb breadcrumbs={[
            {
                link: widgetRoutes.HOME.url({ widgetSlug: widgetSlug }),
                name: definedNotNull(outlet.name),
                image: outlet.logoImageURL()
            }
        ]}/>
        </>
      </StyledLayout>
    </>);
};
export default Home;
const StyledLayout = styled(LayoutWithSidebar)(({ theme }) => ({
    background: theme.colors.white
}));
const AboutEolaContainer = styled.div(({ theme }) => ({
    paddingTop: theme.space[4],
    [theme.mediaQueries.lg]: {
        padding: theme.space[8]
    }
}));
const StyledLink = styled(Link)(() => ({
    textDecoration: 'none',
    display: 'block',
    width: '100%'
}));
const CardContainer = styled(ItemUl)(({ theme }) => ({
    marginTop: `0`,
    paddingTop: 0,
    marginBottom: `${theme.space[4]}px`,
    [theme.mediaQueries.lg]: {
        maxWidth: '560px',
        marginTop: `${theme.space[4]}px`,
        marginBottom: `${theme.space[8]}px`,
        margin: `${theme.space[4]}px auto ${theme.space[8]}px auto`
    }
}));

    async function __Next_Translate__getStaticProps__19831e7cd00__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'library//Home/Home',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19831e7cd00__ as getStaticProps }
  